import { useState, useCallback } from "react";
import EventEmitter from "../utils/emitter/EventEmitter";
import { EMITTER_ERROR, EMITTER_SUCCESS } from "../utils/constants";
import {
  SERVER_MESSAGE_ABSENCE,
  SERVER_MESSAGE_MISPLACED,
} from "../utils/constants/messages";

/**
 * Custom hook to handle API calls with loading and error states.
 * Centralizes try/catch and setLoading logic.
 */
export const useHandleApi = () => {
  const [loading, setLoading] = useState(false);

  const handleApi = useCallback(
    async (
      apiCall,
      {
        onSuccess,
        onError,
        successMessage,
        showSuccess = false,
        showError = true,
        handleFinally,
      } = {},
    ) => {
      setLoading(true);
      try {
        const response = await apiCall();
        if (showSuccess) {
          EventEmitter.emit(
            EMITTER_SUCCESS,
            successMessage || response?.data?.message || SERVER_MESSAGE_ABSENCE,
          );
        }
        if (onSuccess) onSuccess(response);
        return response;
      } catch (error) {
        if (showError) {
          EventEmitter.emit(
            EMITTER_ERROR,
            error?.data?.message || error?.message || SERVER_MESSAGE_MISPLACED,
          );
        }
        if (onError) onError(error);
      } finally {
        setLoading(false);
        if (handleFinally) handleFinally();
      }
    },
    [],
  );

  return { loading, handleApi };
};
